module.exports = __webpack_public_path__ + "static/media/page-header.637961c8.jpg";